import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../admin.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements OnInit {

  public onHide: Subject<string>;
  changeEmailForm: FormGroup;
  email: string;
  username: string;

  constructor(private adminService: AdminService,
              private bsModalRef: BsModalRef,
              private fb: FormBuilder,
              private toastrService: ToastrService) {
  }

  ngOnInit() {
    this.onHide = new Subject();
    this.changeEmailForm = this.fb.group({
        username: new FormControl({value: this.username, disabled: true}),
        email: new FormControl(this.email, [Validators.required, Validators.minLength(4), Validators.email])
      }
    );
  }

  changeEmail() {
    if (this.changeEmailForm.invalid) {
      return;
    }
    this.adminService.changeEmail(this.changeEmailForm.getRawValue()).subscribe(() => {
      this.bsModalRef.hide();
      this.onHide.next(this.changeEmailForm.get('email').value);
      this.toastrService.success('Email successfully modified!');
    });
  }

  cancelModal() {
    this.bsModalRef.hide();
  }
}
